export default function Terms() {
  return (
    <div className="container legal-shell">
      <div className="card">
        <h1>Terms of Service</h1>
        <p>Use AffiTrack lawfully and only with affiliate destinations or campaigns you are authorized to promote.</p>
        <p>You are responsible for the content, tracking links, and marketing traffic you send through the platform.</p>
        <p>Paid subscriptions renew monthly until canceled before the next billing date.</p>
        <p>Team plans are intended for one shared workspace with up to 5 users unless otherwise agreed in writing.</p>
        <p>Refund requests are reviewed case by case for duplicate charges, billing mistakes, or service issues.</p>
        <p>For support, contact support@affitrack.net.</p>
      </div>
    </div>
  );
}
